import Image from 'next/legacy/image';
import { UiButton, UiTitle } from '@frontend/znanie-uikit';
import { useReactiveVar } from '@apollo/client';

import { Link } from 'components/common/Link';

import { themeVar } from 'store/theme';

import { HttpStatus } from 'utils/http-status';

import * as C from './PageError.const';
import * as T from './PageError.types';

import css from './PageError.module.scss';

export const PageError = ({
  statusCode,
  showRedirect,
  showReloadPage,
  children,
}: T.IPageErrorProps) => {
  const { name: themeName } = useReactiveVar(themeVar);

  const renderError = (): JSX.Element => {
    switch (statusCode) {
      case HttpStatus.NOT_FOUND: {
        return <>404 Страница не найдена</>;
      }
      case HttpStatus.INTERNAL_SERVER_ERROR: {
        return (
          <>
            На сервере произошла ошибка. Попробуйте перезагрузить страницу или
            зайти позже
          </>
        );
      }
      default: {
        return <>Произошла ошибка</>;
      }
    }
  };

  return (
    <div className={css.block}>
      <div className={css.img}>
        <Image
          src={
            statusCode === HttpStatus.NOT_FOUND
              ? C.Error404Image
              : C.Error500Image
          }
          layout="fill"
          quality="100"
        />
      </div>
      <div>
        <UiTitle className={css.title} as="h3" align="center" theme={themeName}>
          {children ? children : renderError()}
        </UiTitle>
        {showRedirect && (
          <div className={css.link}>
            <Link href="/">
              <UiButton variant="primary" theme={themeName}>
                Вернуться на главную
              </UiButton>
            </Link>
          </div>
        )}
        {showReloadPage && (
          <div className={css.link}>
            <UiButton
              theme={themeName}
              onClick={() => window.location.reload()}
              variant="primary"
            >
              Перезагрузить страницу
            </UiButton>
          </div>
        )}
      </div>
    </div>
  );
};
